import React, { useEffect } from "react";
import PageHeader from "../../components/Header/PageHeader";
import PageWrapper from "../../components/Page/PageWrapper";
import { CheckBoxOutlined } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import content from "../../content";
import styled from "styled-components";
import Button from "../../components/Button/Button";
import Visualizer from "../Visualizer/Visualizer";
import { Link } from "react-router-dom";
import { getCart } from "../../reducers/project/selectors";
import useDesktop from "../../components/Responsive/useDesktop";
import { ProjectActions } from "../../reducers/project/actionsNames";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 32px;
  width: 700px;
  position: relative;
  background: #ffffff;
  border-radius: 4px;
`;

const Header = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 24px;
  /* identical to box height, or 80% */

  text-align: center;
  letter-spacing: -0.01em;
  color: #1e2029;
`;

const Info = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  margin: 24px 0;
  line-height: 24px;
  /* or 171% */

  text-align: center;
  letter-spacing: -0.01em;

  color: #7a7c8b;
`;

const ConfirmBall = styled.div`
  width: 60px;
  height: 60px;
  position: absolute;
  display: flex;
  top: -38px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #b5d4de;
  border: 16px solid #ffffff;
`;

function OrderConfirmation({}: IOrderConfirmation) {
    const dispatch = useDispatch();
    const cart = useSelector(getCart);

    const desktop = useDesktop();

    useEffect(() => {
        window.localStorage.removeItem("cart");
    }, []);

    const onClick = () => {
        dispatch({ type: ProjectActions.Reset });
        dispatch({ type: ProjectActions.RemoveCart });
    };

    return (
        <>
            <PageWrapper height={"100%"}>
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {desktop && (
                        <Visualizer
                            preview={cart[0]?.components || []}
                            width={"300px"}
                            wrapperStyle={{
                                position: "relative",
                                marginRight: "-60px",
                                zIndex: 100,
                            }}
                        />
                    )}
                    <Wrapper>
                        <ConfirmBall>
                            <img src={"/static/icon/ic24-success.svg"} />
                        </ConfirmBall>
                        <Header>{content.getValue("order_thank_you")}</Header>
                        <Info>{content.getValue("order_finish_info")}</Info>
                        <div>
                            <Link to={"/"}>
                                <Button
                                    onClick={onClick}
                                    style={{
                                        borderRadius: 0,
                                        height: "45px",
                                        width: "100%",
                                        padding: "0 50px",
                                    }}
                                    label={content.getValue("go_back")}
                                />
                            </Link>
                        </div>
                    </Wrapper>
                </div>
            </PageWrapper>
        </>
    );
}

export interface IOrderConfirmation {}

export default OrderConfirmation;
